import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="33" height="34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M27.223 2.792H5.889c-1.466 0-2.666 1.256-2.666 2.792V30.71l5.333-5.584h18.667c1.466 0 2.666-1.256 2.666-2.792V5.584c0-1.536-1.2-2.792-2.666-2.792zm0 19.543H8.556l-2.667 2.792V5.584h21.334v16.751z" fill="#E7EBED" opacity=".6" /></svg>);